import React from 'react';
import {
  AgreementDot,
  BigDot,
  EmptyDot,
  Lane,
  MiddleLine,
  SmallDot,
  VariationSignWrapper,
  Wrapper,
} from './TimestampSigns.styles';

export const HistoricalSign = () => {
  return (
    <Wrapper>
      <Lane />
    </Wrapper>
  );
};

export const AgreementSign = () => {
  return (
    <Wrapper>
      <AgreementDot />
    </Wrapper>
  );
};

export const VariationSign = () => {
  return (
    <Wrapper>
      <VariationSignWrapper width={80} left={0}>
        <MiddleLine />
      </VariationSignWrapper>
    </Wrapper>
  );
};

export const MeanSign = () => {
  return (
    <Wrapper>
      <SmallDot />
    </Wrapper>
  );
};

export const ManagerSign = () => {
  return (
    <Wrapper>
      <EmptyDot />
    </Wrapper>
  );
};

export const ExternalSign = () => {
  return (
    <Wrapper>
      <BigDot />
    </Wrapper>
  );
};
